<template>
  <div>
    <div>
      <span>客户接待>打卡记录</span>
      <el-divider></el-divider>
    </div>
    <div class="layout-page-box">
      <el-form :inline="true" label-width="80px" label-position="right" class="search-form">
        <el-form-item label="院区">
          <el-select v-model="filters.client" placeholder="请选择院区" style="width:90%">
            <el-option v-for="item in clientType" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="部门">
          <el-select v-model="filters.client" placeholder="请选择部门" style="width:90%">
            <el-option v-for="item in departmentType" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-input placeholder="请输入关键字" v-model="filters.keyword">
            <i slot="prefix" class="el-input__icon el-icon-search"></i>
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="query(1)">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="layout-page-box">
      <el-table :data="tableData" style="width: 100%" @selection-change="handleSelectionChange" height="460" :header-cell-style="{color:'#626365'}">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="positionCode" label="账号"></el-table-column>
        <el-table-column prop="positionName" label="姓名"></el-table-column>
        <el-table-column prop="createTime" label="院区"></el-table-column>
        <el-table-column prop="userName" label="部门"></el-table-column>
        <el-table-column prop="userName" label="联系方式"></el-table-column>
        <el-table-column prop="userName" label="状态"></el-table-column>
        <el-table-column prop="userName" label="打卡上线时间"></el-table-column>
        <el-table-column prop="userName" label="打卡下线时间"></el-table-column>
        <el-table-column align="center" label="操作" width="130">
          <template slot-scope="scope">
            <el-button size="mini" type="danger" @click="handleEdit(scope.$index, scope.row)">禁用</el-button>
            <el-button size="mini" type="primary" @click="handleDetail(scope.$index, scope.row)">接待信息</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @size-change="handleSizeChange" @current-change="pageChanged" :current-page="filters.pagination.page" :page-size="filters.pagination.limit" :page-sizes="[10, 20, 30, 50]" layout="total, sizes,prev, pager, next, jumper" :total="filters.pagination.total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      filters: {
        pagination: {
          page: 1,
          limit: 10,
          total: 0
        },
      },
      activeName: 0,
      multipleSelection: [],
      clientType: [{
        value: 0,
        label: '全部'
      }, {
        value: 1,
        label: '伯思立'
      }, {
        value: 2,
        label: '百达丽'
      },],
      departmentType: [{
        value: 0,
        label: '全部'
      }, {
        value: 1,
        label: '客服一部'
      }, {
        value: 2,
        label: '客服二部'
      },],
      tableData: []
    }
  },
  methods: {
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    pageChanged(page) {
      this.filters.pagination.page = page
      this.refresh()
    },
    handleSizeChange(sizes) {
      this.filters.pagination.limit = sizes
      this.refresh()
    },
    refresh() {
      router.push({
        path: this.$route.path,
        query: _.merge({}, this.$route.query, {
          __query: JSON.stringify(this.pagination)
        }, {
            random: Math.random()
          })
      })
    },
    // tab切换事件
    handleClick(tab, event) {
      console.log(tab, event);
    },
    // 查询数据列表
    query(page) {
      var querys = {
        positionCode: this.filters.positionCode,
        positionName: this.filters.positionName,
        page: page,
        size: this.filters.pagination.limit,
      }
      api.requestQuiet('/position/findPosition', querys, (res) => {
        var data = res.data.list
        this.tableData = data
        this.orgData = data
        this.filters.pagination.total = parseInt(res.data.total)
      }, (err) => { })
    },
  },
  mounted() {
    /*this.init();*/
    this.query(this.filters.pagination.page)
  },
  watch: {
    '$route'(to, from) {
      this.query(this.filters.pagination.page)
    }
  }
}
</script>

<style scoped>
</style>